<template>
  <div class="law_statistic-details-table">
    <table class="table_header">
      <thead>
        <tr>
          <td v-if="sortData[0].year">
            {{ $t('Год') }}
          </td>
          <td v-if="sortData[0].totalLawsInYear != null">
            {{ $t('Кол-во законов') }}
          </td>
          <td v-if="sortData[0].wholeLawTypeInYear != null">
            {{ $t('Кол-во цельных законов') }}
          </td>
          <td v-if="sortData[0].normsWithoutByLawsInYear != null">
            {{ $t(' Кол-во норм, по которым не принято подзаконных актов') }}
          </td>
          <td v-if="sortData[0].normDevelopersInYear != null">
            {{ $t('Кол-о государственных органов') }}
          </td>
          
        </tr>
      </thead>
      <tbody>
        <tr 
          v-for="item in sortData"
          :key="item.year"
        >
          <td>
            {{ item.year }}
          </td>
          <td 
            class="value"
            v-if="item.totalLawsInYear != null"
          >
            {{ item.totalLawsInYear }}
          </td>
          <td 
            class="value"
            v-if="item.wholeLawTypeInYear != null"
          >
            {{ item.wholeLawTypeInYear}}
          </td>
          <td v-if="sortData[0].normsWithoutByLawsInYear != null">
            {{ item.normsWithoutByLawsInYear }}
          </td>
          <td v-if="sortData[0].normDevelopersInYear != null">
            {{ item.normDevelopersInYear  }}
          </td>
        </tr>
        <tr class="total">
          <td>
            {{ $t('Итог') }}
          </td>
          <td
           v-if="sortData[0].totalLawsInYear != null"
          >
            {{ total.total }}
          </td>
          <td
            v-if="sortData[0].wholeLawTypeInYear!= null"
          >
            {{ total.totalWhole }}
          </td>
          <td v-if="sortData[0].normsWithoutByLawsInYear != null">
            {{ total.normsWithoutByLawsInYear }}
          </td>
          <td v-if="sortData[0].normDevelopersInYear != null">
            {{ total.normDevelopersInYear  }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'LawStatisitcDetailsYearTable',
  props: {
    data: {
      type: Array,
      required: true
    }
  },

  computed: {
    sortData () {
      return this.data.sort((a, b) => a.year - b.year)
    },
    total () {
      let total = this.data.reduce((result, value) => result + value.totalLawsInYear, 0)
      let totalWhole = this.data.reduce((result, value) => result + value.wholeLawTypeInYear, 0)
      let normsWithoutByLawsInYear = this.data.reduce((result, value) => result + value.normsWithoutByLawsInYear, 0)
      let normDevelopersInYear = this.data.reduce((result, value) => result + value.normDevelopersInYear, 0) 

      return {
        total: total,
        totalWhole: totalWhole,
        normsWithoutByLawsInYear: normsWithoutByLawsInYear,
        normDevelopersInYear: normDevelopersInYear
      }
    }
  },

  methods: {
   
  }
}
</script>
<style lang="scss" scoped>
  .law_statistic-details-table {
    max-width: 600px;
    .table_header {
      thead td, .total td {
        text-align: center;
        font-weight: 600;
        background-color: #dddddd;
        max-width: 300px;
      }

      tbody td {

      }
    }

    .value {
      text-align: center;
    }
  }
</style>